import {applyTransaction} from "@datorama/akita"
import API from "api/API"
import {ApiSystemWidgetResult} from "app/Interface/Api/System/ApiSystemWidget"
import Logger from "logger/logger"
import {useEffect, useState} from "react"
import {Subscription} from "rxjs"
import {systemWidgetQuery, systemWidgetStore} from "store/system/widget/system.widget.store"
import {onEmit} from "utils/onEmit"

export const subscribeSystemWidget = {
  systemWidgets: 'systemWidgets',
  systemModuleWidgetsIsLoading: 'systemModuleWidgetsIsLoading'
}

const SystemWidgetService = (subscribe: string[], caller: string) => {

  const subscribed: Subscription[] = []

  const [systemModuleWidgetsIsLoading, handleIsLoading] = useState<boolean>()
  const [systemWidgets, handleSystemWidgets] = useState<ApiSystemWidgetResult[]>([])

  useEffect(() => {
    if (!subscribe) throw Error(`Service.System.Widget.${caller}: Define what you want to subscribe to`)
    if (!caller) throw Error(`Service.System.Widget.${caller}: Define where you are calling from`)

    subscribe.map(s => {
      if (!Object.keys(subscribeSystemWidget).includes(s))
        throw new Error(`Service.System.Widget.${caller}: Can't subscribe to: ${s}`)
    })

    Logger(`Service.System.Widget.init.${caller}`, subscribe.join(', '))

    let isEffectStale = false

    if (undefined === systemWidgetStore.getValue().loading) {
      API.get<ApiSystemWidgetResult[]>(`/system/widget`).then(get => {
        if (isEffectStale) return
        applyTransaction(() => {
          systemWidgetStore.set(get.data)
          systemWidgetStore.setLoading(false)
        })
      })
    }

    if (subscribe.includes(subscribeSystemWidget.systemModuleWidgetsIsLoading))
      subscribeIsLoading()

    if (subscribe.includes(subscribeSystemWidget.systemWidgets))
      subWidgets()

    return () => {
      Logger(`Service.System.Widget.unloading.${caller}`)
      isEffectStale = true
      subscribed.map(s => s.unsubscribe())
    }
  }, [])

  return {
    systemModuleWidgetsIsLoading,
    systemWidgets,
  }

  function subscribeIsLoading() {
    subscribed.push(onEmit(systemWidgetQuery.selectLoading(), newLoading => {
      handleIsLoading(newLoading)
    }))
  }

  function subWidgets() {
    subscribed.push(onEmit(systemWidgetQuery.selectAll(), newWidgets => {
      handleSystemWidgets(newWidgets)
    }))
  }
}

export default SystemWidgetService
